/**
 * External links centralizados para facilitar cambios futuros
 */
export const EXTERNAL_LINKS = {
  // Calendly para agendar demos
  calendly: "https://calendly.com/hector-jamsom/reunion-1-1-con-jamsom",

  // Redes sociales
  instagram: "https://instagram.com/jamsom.music",

  // Contacto
  email: "mailto:soporte@jamsom.com",

  // WhatsApp
  whatsapp: "https://wa.me/34600000000?text=Hola%2C%20me%20interesa%20saber%20m%C3%A1s%20sobre%20Jamsom%20para%20mi%20escuela%20de%20m%C3%BAsica",
} as const;

/**
 * Servicios de asesoría musical (Stripe Payment Links).
 * ⚠️ Estas URLs son de Stripe TEST. Al pasar a producción, sustituir por los links LIVE.
 */
export const CONSULTING_LINKS = {
  // "Elige tu instrumento" — 34 €
  instrument: "https://buy.stripe.com/test_fZu14f6219WNfJ59xz08g00",
  // "Aprende a tocar en banda" — 49 €
  band: "https://buy.stripe.com/test_14AfZ9cqp4Ct7cz39b08g01",
} as const;

import { getAppUrl } from '@/utils/domain';

/**
 * URLs de la webapp (Backend-webapp)
 * Detecta automáticamente dev vs prod en runtime
 */
const APP_URL = getAppUrl();

/**
 * URLs internas de la aplicación
 */
export const INTERNAL_LINKS = {
  login: `${APP_URL}/login`,
  signup: `${APP_URL}/signup`,
  dashboard: `${APP_URL}/dashboard`,
  legal: "/legal",
  privacidad: "/privacidad",
  cookies: "/cookies",
  terminos: "/terminos",
} as const;

/**
 * URLs de autenticación diferenciadas por landing
 * Cada landing pasa su origen para flujos personalizados
 */
export const AUTH_LINKS = {
  // Escuelas (B2B restringido - solo usuarios pre-registrados)
  escuelas: {
    login: `${APP_URL}/login/escuelas`,
    signup: `${APP_URL}/signup/escuelas`,
  },
  // Jams (B2C libre - cualquiera puede registrarse)
  jams: {
    login: `${APP_URL}/login/jams`,
    signup: `${APP_URL}/signup/jams`,
  },
  // Salas (B2B con aprobación)
  salas: {
    login: `${APP_URL}/login/salas`,
    signup: `${APP_URL}/signup/salas`,
  },
} as const;
